import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { IPagesFullTrustService, ITelemetryService } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
/**
 * Responsible for handling pages fulltrust messages
 */
export class PagesFullTrustMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected fullTrustService?: IPagesFullTrustService,
    telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.pages.fullTrust.enterFullscreen,
      (_) => this.fullTrustService!.enterFullscreen(),
      {
        isPrivate: true,
      }
    );
    this.registerHandler(
      SdkMessageTypes.pages.fullTrust.exitFullscreen,
      (_) => this.fullTrustService!.exitFullscreen(),
      {
        isPrivate: true,
      }
    );
  }

  protected validateDependencies() {
    if (!this.fullTrustService) {
      throw 'No fullTrustService provided';
    }
  }
}
